import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';


const ReviewIndexItem = ({ index, count }) => {
  let reviewIndexItems = [];
  for (let i = 0; i < count; i++) {
    reviewIndexItems.push(
      <div key={i} className={classnames('review-index', {
        'active': index === i
      })}></div>
    );
  }

  return (
    <div className="row justify-content-center review-index-container mt-3 order-sm-2 order-1">
      {reviewIndexItems}
    </div>
  );
};


ReviewIndexItem.propTypes = {
  index: PropTypes.number.isRequired,
  count: PropTypes.number.isRequired
};

export default ReviewIndexItem;



// WEBPACK FOOTER //
// ./src/components/Home/Reviews/ReviewIndex.js